import { Injectable } from '@angular/core';
import { ProcessStepName } from '@common/analytics/model/process-step';
import { RegistrationBase } from '@common/model/registration.base';
import { AuctionService } from '@common/services/auction.service';
import { RegisterFlowLocationService } from '@common/services/register-flow-location.service';
import {
    ProcessStepData,
    ProcessStepServiceBase,
} from '@common/analytics/services/process-step.service.base';

@Injectable()
export class ProcessStepService extends ProcessStepServiceBase {
    data: ProcessStepData = {
        interestedIndividualFlow: {
            person: [
                'personal details',
                'interested individual confirmed',
            ],
            product: null,
        },
        registrationFlow: {
            person: [
                'personal details',
                'product details',
                'registration completed', 
                'email confirmed'
            ],
            product: null,
        },
        decisionFlow: {
            person: [
                'personal details',
                'product details',
                'proposal',
                'decided',
            ],
            product: null,
        },
    };

    constructor(private flowLocationService: RegisterFlowLocationService) {
        super();
    }

    getActiveStep<T extends RegistrationBase>(
        registration: T, activeStep: string,
    ): ProcessStepName {
        const isInterestedIndividual = !AuctionService.getAnyAuction(
            registration,
            registration.community,
        );
        switch (activeStep) {
            case 'person':
                return 'personal details';
            case 'product':
                return 'product details'; 
            case 'proposal':
                return 'proposal';
            case 'survey':
                return 'decided';
            case 'overview':
                if (isInterestedIndividual)
                    return 'interested individual confirmed'; 
                if (registration?.emailConfirmed) return 'email confirmed';
                if (registration?.subscriptionComplete)
                    return 'registration completed';
        }
    }
}